import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { CompanyService }       from '../companies/company.service';
import { ExportEmailComponent } from './export.email.component';
import { SessionService }       from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor (
    private apiService      : ApiService,
    private companyService  : CompanyService,
    private modalService    : NgbModal,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  brandInvoices ( filters : any ) : Promise<string> {
    const url = this.companyService.isBrand('tread')
      ? '/branding_dashboard/tread_connection_csv_export'
      : '/branding_dashboard/bosch_invoices_csv_export';

    return this.email()
      .then(( email : string ) => this.apiService.post(url, {
          email     : email,
          end_date  : filters.endDate   || '*',
          start_date: filters.beginDate || '*'
        }, 'invoice_data')
        .then(() => email));
  }

  brandInvoiceItems ( filters : any ) : Promise<string> {
    return this.email()
      .then(( email : string ) => this.apiService.post('/branding_dashboard/bosch_invoice_items_csv_export', {
          email     : email,
          end_date  : filters.endDate   || '*',
          start_date: filters.beginDate || '*'
        }, 'invoice_data')
        .then(() => email));
  }

  customers ( company = this.sessionService.company(), limited = true ) : Promise<string> {
    const url = limited
      ? '/customers/customer_csv_customer_export'
      : '/customers/customer_csv_admin_export';

    return this.email(this.translateService.instant('CUSTOMER_SPACE.CUSTOMER'))
      .then(( email : string ) => this.apiService.post(url, {
          company_id: company.id,
          email     : email
        }, 'customer_data')
        .then(() => email));
  }

  email ( type ?: string ) : Promise<string> {
    const modal = this.modalService.open(ExportEmailComponent);

    modal.componentInstance.type = type || '';

    return modal.result;
  }

  invoices ( filters : any, company = this.sessionService.company(), limited = true ) : Promise<string> {
    const url = limited
      ? '/invoices/invoice_csv_customer_export'
      : '/invoices/invoice_csv_admin_export';

    return this.email(this.translateService.instant('INVOICE_SPACE.INVOICE'))
      .then(( email : string ) => this.apiService.post(url, {
          company_id: company.id,
          email     : email,
          end_date  : filters.endDate   || '*',
          start_date: filters.beginDate || '*'
        }, 'invoice_data')
        .then(() => email));
  }

  invoiceItems ( filters : any, company = this.sessionService.company(), limited = true ) : Promise<string> {
    const url = limited
      ? '/invoice_items/invoice_item_csv_customer_export'
      : '/invoice_items/invoice_item_csv_admin_export';

    return this.email(this.translateService.instant('INVOICE_SPACE.INVOICE_ITEM'))
      .then(( email : string ) => this.apiService.post(url, {
          company_id: company.id,
          email     : email,
          end_date  : filters.endDate   || '*',
          start_date: filters.beginDate || '*'
        }, 'invoice_data')
        .then(() => email));
  }

  products ( filters : any, company = this.sessionService.company(), limited = true ) : Promise<string> {
    const url = limited
      ? '/products/product_csv_customer_export'
      : '/products/product_csv_admin_export';

    return this.email(this.translateService.instant('PRODUCT_SPACE.PRODUCT'))
      .then(( email : string ) => this.apiService.post(url, {
          company_id: company.id,
          email     : email,
          offset    : filters.offset || 0,
          page_size : filters.limit  || 0
        }, 'product_data')
        .then(() => email));
  }

  vehicles ( company = this.sessionService.company(), limited = true ) : Promise<string> {
    const url = limited
      ? '/vehicles/vehicle_csv_customer_export'
      : '/vehicles/vehicle_csv_admin_export';

    return this.email(this.translateService.instant('VEHICLE_SPACE.VEHICLE'))
      .then(( email : string ) => this.apiService.post(url, {
          company_id: company.id,
          email     : email
        }, 'vehicle_data')
        .then(() => email));
  }

  vendors ( company = this.sessionService.company(), limited = true ) : Promise<string> {
    const url = limited
      ? '/vendors/vendor_csv_customer_export'
      : '/vendors/vendor_csv_admin_export';

    return this.email(this.translateService.instant('VENDOR_SPACE.SUPPLIER'))
      .then(( email : string ) => this.apiService.post(url, {
          company_id: company.id,
          email     : email
        }, 'vendor_data')
        .then(() => email));
  }
}
